import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {SearchResultModel} from "../model/search-result-model";
import {SearchModel} from "../model/search-model";
import {environment} from "../../environments/environment";
import {ParamsBuildHelper} from "../helper/params-build-helper";

@Injectable({
  providedIn: 'root'
})
export class AutocompleteService {

  constructor(private http: HttpClient) {
  }

  autocompleteObligors(search: SearchModel): Observable<Array<SearchResultModel>> {
    return this.http.get<Array<SearchResultModel>>(environment.apiUrl + '/search/autocomplete/obligors' + ParamsBuildHelper.buildGetParams(
      {
        'q': search.obligorName
      }
    ));
  }

  /*  autocompleteCusips(search: SearchModel): Observable<Array<SearchResultModel>> {
      const httpParams = new HttpParams();
      if (search.cusip) httpParams.set('cusip', search.cusip);
      return this.http.get<Array<SearchResultModel>>(environment.apiUrl + '/muni-credit-financials/autocomplete/cusip', {params: httpParams});
    }*/
}
